import React from 'react';
import styles from './productCard.module.css';
import {IProduct} from "../../services/model/Product";
import FooterXsci from "../layout/footer/footer-xsci";
import ProductCard from "./v2/productCard/productCard";

interface Props {
    products: IProduct[];
}

const ProductPage: React.FC<Props> = (props) => {

    return (
        <div style={{backgroundColor:"black"}}>
            {props.products.length !== 0 && (
                <h2 className={styles.product_content_header}>Featured Products</h2>
            )}

            <section className={styles.articles}>
                {props.products.length === 0 ? (
                    <h4>No products found</h4>
                ) : (
                    <>
                        {props.products.map((product, index) => {
                            // Define which products are on sale
                            // const isOnSale = index === 0 || index === 2;
                            const discountedPrice = (product.price * 0.8).toFixed(2); // 20% off

                            return (
                                <>
                                    <ProductCard
                                        product={product}
                                        discountedPrice={discountedPrice}
                                    />
                                </>
                            );
                        })}
                    </>
                )}
            </section>
            <FooterXsci/>
        </div>
    );
};

export default ProductPage;
